import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import FailureScreen from '../../../Shared/FailureScreen/FailureScreen';
import {eErrors} from '../Constants';
import {resetBlock, reportDWH} from '../StandAlonePurchaseSaleSlice';
import {clearStateHistoryAction} from '../../../../utilities/stateHistory/stateHistorySlice';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';

const ErrorPage = (props) => {
  useEffect(() => {
    return () => {
      props.resetBlock();
      props.clearStateHistoryAction();
    };
  }, []);

  let currentPageView = <FailureScreen errorId={props.error.id} onclick={handleErrorPageClose} />;

  function handleErrorPageClose() {
    props.resetBlock();
    switch (props.error.id) {
      case eErrors.REQUIRED_EQUIPMENT_NOT_FOUND:
      case eErrors.SETTLE_DEBT_REQUIRED:
      case eErrors.UPDATE_PAYMENT_METHOD_REQUIRED:
      case eErrors.UPDATE_PAYMENT_METHOD_AND_SETTLE_DEBT_REQUIRED:
        EpiContext.navigateTo(Config.lobbyUrl);
        break;
      case eErrors.TV_SERVICE_NOT_FOUND:
        EpiContext.navigateTo(props.tvSalePage);
        break;
      case eErrors.FINANCIAL_ISSUE:
        props.reportDWH({
          actionType: 'Financial Link Clicked',
          statusText: 'Completed',
          messageText: 'Clicked Financial Link',
          param1: 'DEBT OR NO_PAYMENT',
        });
        EpiContext.navigateTo(Config.lobbyUrl);
        break;
      default:
        EpiContext.navigateTo(Config.lobbyUrl);
        break;
    }
  }

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content'>{currentPageView}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.standAlonePurchaseSaleBlock?.error,
    tvSalePage: state.standAlonePurchaseSaleBlock?.subscribersPageTvSaleLink,
  };
};

const mapDispatchToProps = {resetBlock, clearStateHistoryAction, reportDWH};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
